// @s-nocheck
// TODO Need to convert this file to full typescript instead of javascript by defining types

import React, { useEffect, useRef, useState } from 'react';
import { Navigate } from 'react-router-dom';
import {
    BrowserRouter,
    Routes,
    Route,
    Link,
} from "react-router-dom";
import { connect, useDispatch, useSelector } from 'react-redux';
import { handleConfigsFetch, handleConfigVersionFetch, serverDateTimeDifferenceFetchError, serverDateTimeDifferenceFetchSuccess } from './store/Settings';
import { AuthRoute } from './AuthRoute';

import Login from './pages/Login/Login';
import ConfirmAccount from './pages/ConfirmAccount/ConfirmAccount';
import ConfirmAccountConfirmation from './pages/ConfirmAccountConfirmation/ConfirmAccountConfirmation';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import EmailChangeConfirmation from './pages/EmailChangeConfirmation/EmailChangeConfirmation';
import ForgotPasswordConfirmation from './pages/ForgotPasswordConfirmation/ForgotPasswordConfirmation';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import ResetPasswordConfirmation from './pages/ResetPasswordConfirmation/ResetPasswordConfirmation';
import Account from './pages/Profile/ProfileEdit';

import Auctions from "./pages/Auctions/Auctions";
import AuctionsEditAdd from './pages/Auctions/AuctionsEditAdd';
import LotsEditAdd from './pages/Lots/LotsEditAdd';
import LotTypes from "./pages/LotTypes/LotTypes";
import LotTypeEditAdd from "./pages/LotTypes/LotTypeEditAdd";
import DocumentTemplate from "./pages/Documents/DocumentTemplate";
import DocumentTemplateEditAdd from "./pages/Documents/DocumentTemplateEditAdd";
import Venue from "./pages/Venue/Venue";
import VenueEdit from "./pages/Venue/VenueEdit";
import User from "./pages/Users/User";
import UserEditAdd from "./pages/Users/UserEditAdd";
import LeftSidebar from './components/LeftSidebar/LeftSidebar';
import AuctionManagement from './pages/AuctionManagement/AuctionManagement';
import CataloguePrint from '../src/pages/AuctionManagement/CataloguePrint';
import { hideProgressSpinner } from './helpers/ProgressSpinnerService';
import Contacts from '@/pages/Contacts/Contacts';
import ContactEditAdd from './pages/Contacts/ContactEditAdd';
import Lots from './pages/Lots/Lots';
import Integration from './pages/Integration/Integration';
import ActionEdit from './pages/Integration/ActionEdit';
import ReorderAuction from '@/pages/Auctions/ReorderAuction';
import BankDetails from './pages/BankDetails/BankDetails';
import BankDetailsAddEdit from './pages/BankDetails/BankDetailsAddEdit';
import BiddingCalculations from './pages/BiddingCalculations/BiddingCalculations';
import BiddingCalculationsAddEdit from './pages/BiddingCalculations/BiddingCalculationsAddEdit';
import IncrementTable from './pages/IncrementTable/IncrementTable';
import IncrementTableEditAdd from './pages/IncrementTable/IncrementTableEditAdd';
import BulkUploads from './pages/BulkUpload/BulkUploads';
import BulkUploadsAddEdit from './pages/BulkUpload/BulkUploadAddEdit'
import { useFetchServerDateTimeDifference } from "prembid-shared-library-npm/networking";
import ns from "@/helpers/NotificationService";
import { DialogContentText } from '@mui/material';
import { RootState } from './store/ConfigureStore';
import { PrembidLocalStorage } from 'prembid-shared-library-npm/helpers';
import { onReceiveMessage, clearOnReceiveMessage } from 'prembid-shared-library-npm/signalr';
import useHistory from './hooks/useHistory';
import { SHOW_INTEGRATION } from './helpers/FeatureFlags';

export const activeRouteConfig = {
    auctions: [
        "/auctions",
        "/auctionadd",
        "/auctionedit",
        "/bulkuploads",
        "/bulkuploadsedit",
        "/bulkuploadsadd"
    ],
    auctionManagement: ["/auctionmanagement"],
    lots: [
        "/lots",
        "/lotedit"
    ],
    contacts: [
        "/contacts",
        "/contactedit",
        "/contactadd"
    ],
    users: [
        "/users",
        "/useredit"
    ],
    listingTypes: [
        "/lottypes",
        "/lottypeedit"
    ],
    documents: [
        "/documenttemplates",
        "/documenttemplateedit"
    ],
    bankDetails: [
        "/bankdetails",
        "/bankdetailsedit",
        "/bankdetailsadd"
    ],
    biddingCalculations: [
        "/biddingcalculations",
        "/biddingcalculationsedit",
        "/biddingcalculationsadd"
    ],
    venues: [
        "/venue",
        "/venueedit"
    ],
    integration: [
        "/integration",
        "/action"
    ],
    incrementTable: [
        "/incrementtable",
        "/incrementtableadd",
        "/incrementtableedit"
    ]
}

const unAuthorisedRoutes = {
    '/login': <Login />,
    '/confirmAccount/:userId/:tokenId': <ConfirmAccount />,
    '/confirmAccountConfirmation': <ConfirmAccountConfirmation />,
    '/confirmEmail/:userId/:tokenId': <EmailChangeConfirmation />,
    '/forgotPassword': <ForgotPassword />,
    '/forgotPasswordConfirmation': <ForgotPasswordConfirmation />,
    '/resetPassword/:userId/:tokenId': <ResetPassword />,
    '/ResetPasswordConfirmation': <ResetPasswordConfirmation />,
    '/cataloguePrint/:auctionId': <CataloguePrint />,
}

const authorisedRoutes = {
    "/": <Auctions />,
    "/Auctions": <Auctions />,
    "/AuctionAdd": <AuctionsEditAdd />,
    "/AuctionEdit": <AuctionsEditAdd />,
    "/Venue": <Venue />,
    "/LotAdd": <LotsEditAdd />,
    "/LotEdit": <LotsEditAdd />,
    "/LotTypes": <LotTypes />,
    "/LotTypeAdd": <LotTypeEditAdd />,
    "/LotTypeEdit": <LotTypeEditAdd />,
    "/DocumentTemplates": <DocumentTemplate />,
    "/DocumentTemplateAdd": <DocumentTemplateEditAdd />,
    "/DocumentTemplateEdit": <DocumentTemplateEditAdd />,
    "/VenueEdit": <VenueEdit />,
    "/Users": <User />,
    "/UserEdit": <UserEditAdd />,
    "/AuctionManagement": <AuctionManagement />,
    '/Account': <Account />,
    '/Contacts': <Contacts />,
    '/ContactEdit': <ContactEditAdd />,
    '/ContactAdd': <ContactEditAdd />,
    '/Lots': <Lots />,
    // Integration is switched off for now (helpers/FeatureFlags.ts); its pages are kept.
    ...(SHOW_INTEGRATION ? {
        '/Integration': <Integration />,
        '/Action/:id': <ActionEdit />,
    } : {}),
    '/ReorderAuction/:auctionId': <ReorderAuction />,
    '/BankDetailsEdit/:id': <BankDetailsAddEdit />,
    '/BankDetailsAdd': <BankDetailsAddEdit />,
    '/BankDetails': <BankDetails />,
    '/BiddingCalculationsEdit/:id': <BiddingCalculationsAddEdit />,
    '/BiddingCalculationsAdd': <BiddingCalculationsAddEdit />,
    '/BiddingCalculations': <BiddingCalculations />,
    '/IncrementTable': <IncrementTable />,
    '/IncrementTableAdd': <IncrementTableEditAdd />,
    '/IncrementTableEdit/:id': <IncrementTableEditAdd />,
    '/BulkUploadsEdit/:id': <BulkUploadsAddEdit />,
    '/BulkUploadsAdd': <BulkUploadsAddEdit />,
    '/BulkUploads/:auctionId': <BulkUploads />
}

interface Props {
    handleConfigVersionFetch_d: () => void,
    handleConfigsFetch_d: (version: any) => void,
    configVersionRetrieved: boolean,
    configsRetrieved: boolean,
    settings: any,
    configVersion: any,
}


const RoutesComponent: React.FC<Props> = (props) => {
    const {
        handleConfigVersionFetch_d,
        handleConfigsFetch_d,
        configVersionRetrieved,
        configsRetrieved,
        settings,
        configVersion,
    } = props;

    const dispatch = useDispatch();
    const history = useHistory();

    const navigateLogout = () => {
        PrembidLocalStorage.clearCurrentUser();
        let path = "/login";
        history.push(path);
    };

    useEffect(() => {
        const callbackId = onReceiveMessage((message: string) => {
            if (message) {
                var payload = JSON.parse(message);

                if (payload?.data) {
                    const { messageSubject = undefined, userId = undefined } = payload.data;

                    console.log(`${messageSubject}=>`, PrembidLocalStorage.currentUser?.userId, userId);

                    if (messageSubject === "UserRolesUpdated" && PrembidLocalStorage.currentUser?.userId === userId) {
                        navigateLogout();

                        ns.showDialog({
                            title: "Session Expired",
                            message: "Your session has been expired by an administrator. Please login again or contact the administrator.",
                            onSubmit: () => { },
                            locales: { submitText: "Ok" }
                        })
                    }
                }
            }
        });

        return () => clearOnReceiveMessage(callbackId);
    }, []);

    // Local time sent with the server time request. One value per attempt (it is part of the request key), so every
    // re-check below sends a fresh time.
    //This must stay as new Date() to get the local time. Do not change
    const [clientTimestamp, setClientTimestamp] = useState<number>(() => new Date().getTime());
    // The first answer also loads the configs; later re-checks only refresh the time difference.
    const configsRequested = useRef(false);
    const lastOffset = useRef<number | undefined>(undefined);
    // Set while a suspected clock change is being confirmed with the server.
    const verifyingClock = useRef(false);
    const clockDialogOpen = useRef(false);
    // Device clock vs the browser's steady timer (performance.now(), which the user cannot change). A background tab
    // or a sleeping computer slows both together; only a changed device clock pulls them apart.
    const clockBaseline = useRef({ wall: Date.now(), steady: performance.now() });
    const resetClockBaseline = () => { clockBaseline.current = { wall: Date.now(), steady: performance.now() }; };

    const showClockSyncDialog = () => {
        if (clockDialogOpen.current) return;
        clockDialogOpen.current = true;
        ns.showDialog({
            title: "Sync Your Clock for Optimal Experience",
            content: (
                <>
                    <DialogContentText className="mt-3 mb-3">To ensure the best user experience, we've noticed your device's time is out of sync with our server.</DialogContentText>

                    <DialogContentText className="mb-3">Please click the 'Sync' button to resync your clock and maintain seamless access to all features. Please note this will refresh your browser.</DialogContentText>

                    <DialogContentText>Thank you for helping us enhance your experience! </DialogContentText>
                </>
            ),
            locales: {
                submitText: "Sync",
            },
            onSubmit: () => { window.location.reload(); },
            allowCloseOnBackDropClick: false
        });
    };

    // Ask the server again (fresh local time); the answer decides whether the device clock really changed.
    const recheckServerTime = () => {
        if (verifyingClock.current || clockDialogOpen.current) return;
        verifyingClock.current = true;
        setClientTimestamp(new Date().getTime());
    };

    const { refetch: refreshServerTimeOffset } = useFetchServerDateTimeDifference({ pathParams: { localDateTimeTicks: clientTimestamp } },
        {
            enabled: false,
            onSuccess(res) {
                //This must stay as new Date() to get the local time. Do not change
                const nowTimeStamp: number = new Date().getTime();

                const diff: number = res?.diff;
                const roundTrip = Math.abs(nowTimeStamp - clientTimestamp);
                const estimatedRequestTime = roundTrip / 2;

                const finalOffset = diff - estimatedRequestTime;
                const offset = Math.abs(finalOffset) <= 400 ? 0 : finalOffset;

                // A re-check: the device clock only changed if its difference to the server moved (more than 20s).
                // A slowed background tab or a sleep leaves it the same, so then the check simply starts again.
                if (verifyingClock.current) {
                    verifyingClock.current = false;
                    if (lastOffset.current !== undefined && Math.abs(offset - lastOffset.current) > 20000) showClockSyncDialog();
                }
                lastOffset.current = offset;
                resetClockBaseline();

                dispatch(serverDateTimeDifferenceFetchSuccess(offset));
                if (!configsRequested.current) {
                    configsRequested.current = true;
                    handleConfigVersionFetch_d();
                }
            },
            onError(error) {
                verifyingClock.current = false;
                // Only the first load reports an error; a failed re-check keeps the time difference already known.
                if (configsRequested.current) return;
                //TODO: We need a new Error Page that we redirect to incase this fails. Failure could be due to internet, server etc
                dispatch(serverDateTimeDifferenceFetchError(error?.message))
            }
        }
    );

    const serverTimeOffsetTimerTickInterval = () => {
        resetClockBaseline();

        const newWorker = new Worker('/worker.js');
        newWorker.onmessage = function (e) {
            const wallElapsed = Date.now() - clockBaseline.current.wall;
            const steadyElapsed = performance.now() - clockBaseline.current.steady;
            if (Math.abs(wallElapsed - steadyElapsed) > 20000) recheckServerTime();
        };

        newWorker.postMessage({ action: 'start', interval: 1000 });

        // Back on the tab (it may have been in the background or asleep for a long time): check the time with the server.
        const onVisibilityChange = () => {
            if (document.visibilityState === "visible") recheckServerTime();
        };
        document.addEventListener("visibilitychange", onVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", onVisibilityChange);
            newWorker.postMessage({ action: 'stop' });
            newWorker.terminate();
        };
    }

    //This post is used to get the difference between the client and server time and thereafter used to set the timers in the app
    // (runs again with a fresh local time for every re-check)
    useEffect(() => {
        refreshServerTimeOffset();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [clientTimestamp]);

    useEffect(() => {
        if (configVersionRetrieved && configsRetrieved) {
            return serverTimeOffsetTimerTickInterval();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configVersionRetrieved, configsRetrieved]);

    useEffect(() => {
        if (configVersionRetrieved) {
            handleConfigsFetch_d(configVersion);
        }
    }, [configVersionRetrieved]);

    useEffect(() => {
        if (configVersionRetrieved && configsRetrieved) {
            if (document?.getElementById("favicon") && settings?.VendorName && settings?.VendorFaviconUrl) {
                document.title = settings.VendorName

                var link = document.querySelector("link[id~='favicon']");
                if (!link) {
                    link = document.createElement('link');
                    link.id = 'favicon';
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
                (link as HTMLAnchorElement).href = settings.VendorFaviconUrl;
            }
            hideProgressSpinner();
        }
    }, [configVersionRetrieved, configsRetrieved, settings?.VendorFaviconUrl, settings?.VendorName]);

    useEffect(() => {
        if (settings?.Styles) {
            Object.keys(settings.Styles).forEach(x => {
                if (x.toLowerCase() === 'fontfilename') {
                    var newStyle = document.createElement('style');
                    newStyle.appendChild(document.createTextNode("\
                        @font-face {\
                            font-family: customFont;\
                            src: url('/api/Vendor/RetrieveFont/" + settings.VendorName + "/" + settings.Styles[x] + "');\
                        }\
                    "));

                    document.head.appendChild(newStyle);
                } else {
                    document.documentElement.style.setProperty(`--${x.toLowerCase()}`, settings.Styles[x]);
                }
            })
        }
    }, [settings]);

    return (<>
        {configVersionRetrieved && configsRetrieved && <div>
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />
                {Object.keys(unAuthorisedRoutes).map(path => (<Route path={path} element={unAuthorisedRoutes[path]} />))}

                <Route element={<AuthRoute />}>
                    <Route element={<LeftSidebar />}>
                        {Object.keys(authorisedRoutes).map((path) => (
                            <Route path={path} element={authorisedRoutes[path]} />
                        ))}
                    </Route>
                </Route>
                <Route path="/*" element={<Navigate to="/" />} />
            </Routes>
        </div>}
    </>
    )
}

const mapStateToProps = (state: any) => ({
    configsRetrieved: state.settings.configsRetrieved,
    configVersionRetrieved: state.settings.configVersionRetrieved,
    settings: state.settings.settings,
    configVersion: state.settings.configVersion,
})

const mapDispatchToProps = (dispatch: any) => {
    return {
        handleConfigVersionFetch_d: () => dispatch(handleConfigVersionFetch()),
        handleConfigsFetch_d: (version: any) => dispatch(handleConfigsFetch(version))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(RoutesComponent);
